module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAZCAMAAACbxPdpAAAARVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////9SnXPCAAAAF3RSTlMAzI+YxjhIdGVgA1Gvmb5CIBozKRKDbGX+nl0AAAB0SURBVDjL7dFtCoAgDIDhWZbLj8y07n/UmhGEZO0Avv8GD2wwqLdYOwArJYTkUSPYVDV60zSuQCU0On9m64ok0RMZxEACncs7rHht1iQXErtz/lsGc50bFObtseuLJEkP/00ExwYreS4ExYUQZ0mQk9bP6QAvDQRgjGcnjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/arrows_carousel_icon.png
// module id = VIWu
// module chunks = 0